import React from 'react';
import { ApplyCEButtonStyle, ApplyCEIconStyle, ApplyCETextStyle } from './ApplyCEButton.style';
import { ApplyCEButtonProps } from './ApplyCEButton.types';

const ApplyStock: React.FC<ApplyCEButtonProps> = ({ onClick }) => {
  return (
    <ApplyCEButtonStyle onClick={onClick}>
      <ApplyCEIconStyle />
      <ApplyCETextStyle>Appliquer Stock +</ApplyCETextStyle>
    </ApplyCEButtonStyle>
  );
};

export default ApplyStock;
